import { Input, Select } from "antd";
import countryCodes from "../data/country-phone-codes.json";
import Helper from "../Helper";

/**
 * Ülke kodlu telefon girişi — `antd-country-phone-input` paketinin yerine geçer.
 * O paket antd 4.x'e çakılıydı (peer: antd 4.x) ve v5 ile test edilmemişti; ayrıca çalışması için
 * kendi ConfigProvider'ına ülke listesi geçirmeyi zorunlu kılıyordu.
 *
 * Form değeri v4'teki ile BİREBİR aynı: { code: number, phone: string }
 * → PatientCreateEdit'teki phoneCode/phone ayrıştırma mantığı değişmedi.
 */
const options = countryCodes.map((c) => ({
    value: c.code,
    label: `${c.emoji} +${c.code}`,
    title: `${c.name} (+${c.code})`,
    search: `${c.name} ${c.short} ${c.code}`.toLowerCase(),
}));

/**
 * DİKKAT: addonBefore slot'u ülke kodu Select'ine ait — dışarıdan geçirilen bir addonBefore
 * sessizce ezilirdi (label hiç render edilmezdi). Bu yüzden burada tüketilip yok sayılıyor;
 * telefon label'ı çağıran tarafta input'un DIŞINDA <AddonBefore external /> ile veriliyor.
 */
export default function PhoneInput({ value = {}, onChange, disabled, inputProps, addonBefore: _ignoredAddon, ...rest })
{
    const emit = (next) => onChange?.({ ...value, ...next });

    /**
     * Silme tuşu bir BİÇİM karakterine denk geldiğinde — "(555)" sonundaki parantez veya
     * gruplar arasındaki boşluk — ham metin kısalır ama rakam sayısı değişmez. phoneFormat
     * aynı sonucu geri üretir, tuş hiç işlememiş gibi görünür: alan kodu bir türlü silinemez,
     * Ctrl+A ile temizlemek gerekirdi. Bu durumda bir rakam da eksiltiyoruz — biçim karakteri
     * ait olduğu rakamla birlikte gider, silme normal şekilde geriye yürür.
     *
     * Rakamlar 10 ile sınırlanıyor: phoneFormat maskeyi SON 10 hanenin üzerine kuruyor, fazlası
     * girildiğinde numara kaydırılırdı (11. hane basılınca "(551) 234 56 78"). Fazla hane
     * yok sayılır.
     */
    const handleChange = (e) => {
        const raw = e.target.value ?? '';
        const prev = value.phone ?? '';
        const prevDigits = prev.replace(/\D+/g, '');
        let digits = raw.replace(/\D+/g, '');

        const isDelete = raw.length < prev.length;
        if (isDelete && digits === prevDigits)
            digits = digits.slice(0, -1);

        emit({ phone: Helper.Phone.phoneFormat(digits.slice(0, 10)) });
    };

    return (
        <Input
            {...rest}
            {...inputProps}          /* eski paketin API'si: inputMode/type/onKeyDown/onPaste doğrudan input'a geçer */
            disabled={disabled}
            value={value.phone}
            onChange={handleChange}
            addonBefore={
                <Select
                    showSearch
                    disabled={disabled}
                    value={value.code}
                    onChange={(code) => emit({ code })}
                    options={options}
                    optionFilterProp="search"
                    filterOption={(input, option) => option.search.includes(input.toLowerCase())}
                    style={{ width: 110 }}
                    popupMatchSelectWidth={280}
                />
            }
        />
    );
}
